import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    if (localStorage.getItem("language") === null) {
      localStorage.setItem("language", "fr");
    }
   
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts